import { useEffect, useState } from "react";

const KEY = "nearme_theme";
const OPTS = ["system", "light", "dark"];

function apply(mode) {
  const wantsDark =
    mode === "dark" ||
    (mode === "system" &&
      window.matchMedia("(prefers-color-scheme: dark)").matches);
  document.documentElement.classList.toggle("dark", wantsDark);
}

export function useTheme() {
  const [mode, setMode] = useState(() => {
    const stored = localStorage.getItem(KEY);
    return OPTS.includes(stored) ? stored : "system";
  });

  useEffect(() => {
    apply(mode);
    localStorage.setItem(KEY, mode);
    if (mode === "system") {
      const mq = window.matchMedia("(prefers-color-scheme: dark)");
      const handler = () => apply("system");
      mq.addEventListener("change", handler);
      return () => mq.removeEventListener("change", handler);
    }
  }, [mode]);

  return { mode, setMode, options: OPTS };
}
